<div class="left-side-list">

  <hhsg-filter 
  [sortOptions]="sortOptions" 
  [legendTemplate]="legendTemplate"
  [hasLegends] = "hasLegends"
  (sortTypeChangeEvent)="onSortTypesDropDownChanged($event)" 
  (selectedFilterEvent)="selectedFilter" 
  (setSelectedFilterEvent)="setSelectedFilter" 
  (sortUpDownChangeEvent) = "sortUpDownChange()"
  (searchChangeEvent)="onSearchChangeEvent($event)"></hhsg-filter>

  <hhsg-mapping-list 
  [mappings] = "mappings" 
  [hasLegends] = "hasLegends"
  [selection] = "selection"
  (onSelectionEvent) = "onSelection($event)"
  [mappingDetailTemplate]="mappingDetailTemplate"></hhsg-mapping-list>
</div>
